import { render, staticRenderFns } from "./CareerStatsTable.vue?vue&type=template&id=e34fbf24&scoped=true"
import script from "./CareerStatsTable.vue?vue&type=script&lang=js"
export * from "./CareerStatsTable.vue?vue&type=script&lang=js"
import style0 from "./CareerStatsTable.vue?vue&type=style&index=0&id=e34fbf24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34fbf24",
  null
  
)

export default component.exports